/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_Tier_PremierInputs */



/**
* | output |
* | --- |
* | "Premier" |
*
* @param {Meta_Event_Tier_PremierInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_tier_premier = /** @type {((inputs?: Meta_Event_Tier_PremierInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_Tier_PremierInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Premier")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Premier")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("顶级")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("頂級")
	if (locale === "ko") return /** @type {LocalizedString} */ ("프리미어")
	return /** @type {LocalizedString} */ ("Premier")
});